import { useEffect, useRef } from "react";
import GoogleMeetServices from "../../../services/GoogleMeetService";

export default function GoogleCallback() {
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;

    const code = new URLSearchParams(window.location.search).get("code");
    if (!code) return;

    done.current = true;

    GoogleMeetServices.exchangeCode(code)
      .then(token => {
        window.opener.postMessage(
          { type: "GOOGLE_OAUTH_SUCCESS", token },
          window.location.origin
        );
        window.close();
      });
  }, []);

  return <p>Connecting to Google…</p>;
}
